/**
 * Shared organization display-name helper.
 *
 * Falls back to the raw organization_id when no name is set (or it's blank),
 * so the UI never renders an empty label. Used by both UserAnalytics.tsx and
 * CompanyDrilldown.tsx wherever an org name needs to be shown.
 */
export const getOrganizationName = (
  organizationName: string | null | undefined,
  organizationId: string
): string => organizationName?.trim() || organizationId;
